import React, { Component } from 'react';
import Routes from "./Routes";
import "./App.css";
import CookieConsent from "react-cookie-consent";
import ReactGA from 'react-ga'

class App extends Component {

    render() {

        const handleAcceptCookie = () => {
            console.log('calling ga');
            ReactGA.initialize('UA-197023269-1');
            ReactGA.pageview(window.location.pathname + window.location.search);
        };
        return (
            <div>
                <CookieConsent enableDeclineButton
                    onAccept={handleAcceptCookie}
                    style={{ background: '#000' }}
                    declineButtonStyle={{ background: '#a90606' }}
                    buttonStyle={{
                        background: 'green'
                    }}
                    flipButtons
                    declineButtonText="Non accetto"
                    buttonText="Accetto"
                >
                    Questo sito usa google analytics cookies.
                </CookieConsent>
                <Routes />
            </div>
        );
    }
}

export default App;

